import React from "react"
import PropTypes from "prop-types"

const Lock = props => {
  const { color, width, height, ...other } = props

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28.974 30"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
    >
      <path d="M26.935,50.785H2.039A2.039,2.039,0,0,1,0,48.746V31.328a2.039,2.039,0,0,1,2.039-2.039h24.9a2.039,2.039,0,0,1,2.039,2.039V48.746a2.039,2.039,0,0,1-2.039,2.039" transform="translate(0 -20.785)"/>
      <path d="M37.663,8.523H35.341a6.2,6.2,0,0,0-12.4,0H20.617a8.523,8.523,0,0,1,17.046,0" transform="translate(-14.631)"/>
      <path d="M46.538,55.795a2.324,2.324,0,1,1-2.324-2.324,2.324,2.324,0,0,1,2.324,2.324" transform="translate(-29.728 -37.945)" fill="#fff"/>
      <rect width="1.452" height="3.505" transform="translate(13.761 19.474)" fill="#fff"/>
    </svg>
  )
}

Lock.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
}

Lock.defaultProps = {
  color: "#bec0c6",
  width: 28.974,
  height: 30,
}

export default Lock
